module.exports = __webpack_public_path__ + "static/media/Tech __ Neuroscience Intersections.8f7ce483.png";